import { Dispatch } from '@reduxjs/toolkit';
import { setPlayerAttributes } from '../actions';
import { AppState } from '../store';

export function getPlayerAttributes(): ReduxAction {
  return async (dispatch: Dispatch, getState: () => AppState) => {
    const {
      general: { appConfiguration, accessToken },
    } = getState();

    try {
      const data = await fetch(`${appConfiguration.VITE_API_SALES_CONFIGURATION}/api/playerAttribute`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const playerAttributes = await data.json();
      dispatch(setPlayerAttributes(playerAttributes));
    } catch (error) {
      console.error(error);
    }
  };
}
